import React, {ButtonHTMLAttributes} from 'react'
import {css} from '@emotion/core'
import styled from '@emotion/styled'
import Heading from '../../../../designSystem/Heading'
import {MdChevronRight} from 'react-icons/md'

const ChevronRightElement = styled(MdChevronRight)(
  ({theme}) => css`
    width: 24px;
    height: 24px;
    color: ${theme.colors.promotionComparisonArrowRight};
    /* @mirror */
  `
)
const StyledButton = styled('button')(
  ({theme}) => css`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    position: relative;
    text-decoration: none;
    padding: 0;
    border: none;
    background: transparent;
    color: ${theme.colors.defaultTextColor};

    &:hover,
    &:focus {
      text-decoration: none;
      color: ${theme.colors.defaultTextColor};
    }
  `
)

const ArrowLink = ({
  children,
  ...restButtonProps
}: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <StyledButton {...restButtonProps}>
      <Heading appearance="title3" marginBottomSize="s000">
        {children}
      </Heading>
      <ChevronRightElement />
    </StyledButton>
  )
}

export default ArrowLink
